import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFnacComponent } from './simple-icons-fnac.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFnacComponent ],
    exports:      [ SimpleIconsFnacComponent ],
    bootstrap:    []
})
export class SimpleIconsFnacModule {}
